import {
	CAMP_SLUG_MAX_LENGTH,
	ORGANIZER_SLUG_MAX_LENGTH,
	SLUG_MIN_LENGTH,
	SLUG_PATTERN,
} from "./catalog";

/** Words the camp-api keeps for its own routes; an organizer slug may not be one of them. */
const RESERVED_SLUGS: ReadonlySet<string> = new Set([
	"admin",
	"api",
	"app",
	"camp",
	"camps",
	"public",
	"organizers",
	"registrations",
	"editions",
	"health",
	"www",
	"me",
	"new",
	"login",
	"static",
	"assets",
]);

export type SlugProblem = "tooShort" | "tooLong" | "malformed" | "reserved";

/** Why an organizer slug would be refused, or null when it is fine (3..40, reserved words out). */
export function organizerSlugProblem(slug: string): SlugProblem | null {
	if (slug.length < SLUG_MIN_LENGTH) return "tooShort";
	if (slug.length > ORGANIZER_SLUG_MAX_LENGTH) return "tooLong";
	if (!SLUG_PATTERN.test(slug)) return "malformed";
	return RESERVED_SLUGS.has(slug) ? "reserved" : null;
}

const TRANSLITERATIONS = new Map([
	["ß", "ss"],
	["ä", "ae"],
	["ö", "oe"],
	["ü", "ue"],
]);

/** A suggested slug for a name; empty when nothing usable remains. */
export function slugFromName(name: string, maxLength = CAMP_SLUG_MAX_LENGTH): string {
	const ascii = name
		.toLowerCase()
		.replace(/[ßäöü]/g, (char) => TRANSLITERATIONS.get(char) ?? char)
		.normalize("NFKD")
		.replace(/[\u0300-\u036f]/g, "");
	const hyphenated = ascii.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
	return hyphenated.slice(0, maxLength).replace(/-+$/, "");
}
